import { render } from "./SearchFacet.vue?vue&type=template&id=801dfa1e"
import script from "./SearchFacet.vue?vue&type=script&lang=js"
export * from "./SearchFacet.vue?vue&type=script&lang=js"

import "./SearchFacet.vue?vue&type=style&index=0&id=801dfa1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__